<template>
  <div>
    <!-- <Header /> -->
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="w-full p-5">
          <div class="flex justify-end items-center p-2">
            <div
              class="inline-flex rounded-full border border-gray-300 overflow-hidden"
            >
              <button
                @click="setTab('list')"
                :class="[
                  'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                  tab === 'list'
                    ? 'bg-blue-100 text-blue-600'
                    : 'bg-white text-gray-600',
                ]"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>

              <button
                @click="setTab('card')"
                :class="[
                  'px-6 py-2 flex items-center gap-1 transition-all duration-200',
                  tab === 'card'
                    ? 'bg-blue-100 text-blue-600'
                    : 'bg-white text-gray-600',
                ]"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 4h6v6H4V4zm10 0h6v6h-6V4zM4 14h6v6H4v-6zm10 0h6v6h-6v-6z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- list -->

        <div v-if="tab === 'list'" class="px-5 lg:px-10 pb-4">
          <div class="flex items-center justify-between">
            <div class="flex flex-col lg:flex-row justify-between w-full">
              <h1 class="text-lg font-semibold">
                Assignments
                <span v-if="assignmentInfo != null">
                  ({{ this.assignmentInfo.count }})
                </span>
              </h1>
              <div class="flex flex-col lg:flex-row gap-3">
                <div>
                <select
                 ref="selectFilter"
                  name="model_select"
                  id="model_select"
                  v-model="selected_filter"
                  @change="getdetails(1)"
                  class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm cursor-pointer text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                >
                  <option value="" disabled selected>Select sorting</option>
                  <option value="title">A to Z</option>
                  <option value="-title">Z to A</option>
                  <option value="created_at">New to Old</option>
                  <option value="-created_at">Old to New</option>
                </select>
              </div>

              <div class="relative w-full md:max-w-64">
                <form @submit.prevent="getdetails(1)">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getdetails(1)"
                    class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>
              </div>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer">
            <p
              @click="this.submitted = 'assignment'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'assignment',
              }"
            >
              Assignments
            </p>
            <p
              @click="this.submitted = 'submitted'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'submitted',
              }"
            >
              Submitted
            </p>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="submitted === 'assignment'">
            <div v-if="assignmentInfo?.data?.length > 0" class="mt-5 space-y-4">
              <div class="w-full overflow-scroll">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <th class="px-4 py-3">Name</th>
                      <th class="px-4 py-3">Title</th>
                      <th class="px-4 py-3">Due date</th>
                      <th class="px-4 py-3">Descrption</th>
                      <th class="px-4 py-3">Download</th>
                      <th class="px-4 py-3">Status</th>
                      <th class="px-4 py-3">Action</th>
                      <th class="px-4 py-3">Remark / Grade</th>
                      <th class="px-4 py-3">Feedback</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(assignment, index) in assignmentInfo.data"
                      :key="assignment.id"
                      @click="pushDetailPage(assignment.id)"
                      class="border-b pb-3 hover:bg-gray-100 cursor-pointer"
                    >
                      <td class="px-4 py-3">
                        <img
                          class="w-10 h-10 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <td class="px-6 py-3 md:w-[250px]">
                        <p class="text-sm font-semibold text-gray-800">
                          <span class="text-gray-500">{{
                            assignment.title.slice(
                              0,
                              assignment.visibleTitleLengths
                            )
                          }}</span>

                          <!-- {{ assignment.visibleTitleLengths }} -->
                          <button
                            v-if="
                              assignment.title.length >
                              assignment.visibleTitleLengths
                            "
                            @click.stop="showMore(index, 'title')"
                            class="text-blue-500 ml-2"
                          >
                            Read More
                          </button>

                          <button
                            v-if="
                              assignment.title.length > 50 &&
                              assignment.title.length <
                                assignment.visibleTitleLengths
                            "
                            @click.stop="showLess(index, 'title')"
                            class="text-blue-500 ml-2"
                          >
                            See Less
                          </button>
                        </p>
                      </td>
                      <td class="px-4 py-3">
                        <p class="text-xs text-gray-500">
                          {{ assignment.duedate }}
                        </p>
                      </td>
                      <!-- {{ assignment.visibleLengths }} -->
                      <td class="px-4 py-3 md:!w-[250px]">
                        <p class="text-xs text-gray-600">
                          <span class="text-gray-500">{{
                            assignment.description.slice(
                              0,
                              assignment.visibleLengths
                            ) || "NA"
                          }}</span>

                          <!-- {{ assignment.visibleLengths }} -->
                          <button
                            v-if="
                              assignment.description.length >
                              assignment.visibleLengths
                            "
                            @click.stop="showMore(index, 'description')"
                            class="text-blue-500 ml-2"
                          >
                            Read More
                          </button>

                          <button
                            v-if="
                              assignment.description.length > 50 &&
                              assignment.description.length <
                                assignment.visibleLengths
                            "
                            @click.stop="showLess(index, 'description')"
                            class="text-blue-500 ml-2"
                          >
                            See Less
                          </button>
                        </p>
                      </td>
                      <td class="px-4 py-3">
                        <a
                          :href="assignment.file"
                          @click.stop
                          target="_blank"
                          download
                        >
                          <img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                          />
                        </a>
                      </td>

                      <td class="px-4 py-3">
                        <p
                          v-if="
                            assignment.student_assignment_data?.verify_status ==
                            'submitted'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else-if="
                            assignment.student_assignment_data?.verify_status ==
                            'rejected'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid black; color: black"
                        >
                          <a class="text-black">N/A</a>
                        </p>
                      </td>
                      <td class="px-4 py-3" v-if="assignment">
                        <button
                          v-if="
                            !assignment.student_assignment_data ||
                            (assignment.student_assignment_data
                              ?.verify_status != 'accepted' &&
                              assignment.student_assignment_data
                                ?.verify_status != 'submitted')
                          "
                          @click.stop="
                            this.assignmentPopup = !this.assignmentPopup;
                            this.assignmentId = assignment.id;
                          "
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'bg-gray-200 text-black cursor-not-allowed'
                              : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                          "
                          class="text-xs rounded px-3 py-1"
                        >
                          Submit
                        </button>
                        <button
                          v-else-if="
                            assignment.student_assignment_data != null && [
                              assignment.student_assignment_data
                                ?.verify_status == 'submitted' ||
                                assignment.student_assignment_data
                                  ?.verify_status == 'rejected',
                            ] &&
                            assignment.student_assignment_data?.verify_status !=
                              'accepted'
                          "
                          @click.stop="checkAssignment(assignment)"
                          :disabled="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          :class="
                            assignmentId === assignment.id && assignmentPopup
                              ? 'cursor-not-allowed'
                              : 'cursor-pointer text-white'
                          "
                        >
                          <img
                            src="@/assets/edit.svg"
                            alt=""
                            class="w-6 h-6 object-contain"
                          />
                        </button>
                        <p v-else>-</p>
                      </td>
                      <td class="px-4 py-3 text-gray-500">
                        {{ assignment.student_assignment_data?.remark || "-" }}
                      </td>

                      <td
                        class="px-4 py-3 text-gray-500"
                        v-if="assignment.is_active == true"
                      >
                        <div
                          v-if="
                            assignment.student_assignment_data != null && [
                              assignment.student_assignment_data
                                ?.verify_status === 'accepted' ||
                                assignment.student_assignment_data
                                  ?.verify_status === 'rejected',
                            ]
                          "
                        >
                          <button
                            v-if="assignment.assignment_feedback.user_feedback"
                            @click.stop="openfeedback(assignment.id)"
                            class="flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-600 rounded-md hover:bg-blue-200 transition-all"
                            title="View Full Description"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-4 w-4"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                              />
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                              />
                            </svg>
                            <span class="text-xs font-medium"
                              >View Feedback</span
                            >
                          </button>
                          <button
                            v-else
                            class="text-blues text-sm"
                            @click.stop="
                              this.feedbackPopup = !this.feedbackPopup;
                              this.assignmentId = assignment.id;
                            "
                          >
                            Click
                          </button>
                        </div>
                        <div v-else>-</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="getdetails"
                />
              </div>
            </div>

            <div v-else class="text-gray-500 mt-5">No data found</div>
          </div>
          <div class="h-full" v-else-if="submitted == 'submitted'">
            <div v-if="assignmentInfo?.data?.length > 0" class="mt-5 space-y-4">
              <div class="w-full overflow-scroll">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <th class="px-4 py-3">Name</th>
                      <th class="px-4 py-3">Title</th>
                      <th class="px-4 py-3">Due date</th>
                      <th class="px-4 py-3">Descrption</th>
                      <th class="px-4 py-3">Attempt</th>
                      <th class="px-4 py-3">Download</th>
                      <th class="px-4 py-3">Status</th>
                      <th class="px-4 py-3">Remark / Grade</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(assignment, index) in assignmentInfo.data"
                      :key="assignment.id"
                      @click="pushDetailPage(assignment.id)"
                      class="border-b pb-3 hover:bg-gray-100 cursor-pointer"
                    >
                      <td class="px-4 py-3">
                        <img
                          class="w-10 h-10 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <!-- <td class="px-4 py-3 md:w-[200px] tooltip">
                        <router-link
                          :to="{
                            name: 'AssignmentDetail',
                            params: { assignment_id: assignment.id },
                          }"
                        >
                          <p
                            class="text-sm font-semibold line-clamp-3 text-gray-800"
                          >
                            {{ assignment.title }}
                          </p>
                        </router-link>
                        <span class="tooltiptext text-xs p-2">
                          {{ assignment.title }}
                        </span>
                      </td> -->
                      <td class="px-6 py-3 md:w-[250px]">
                        <p class="text-sm font-semibold text-gray-800">
                          <span class="text-gray-500">{{
                            assignment.title.slice(
                              0,
                              assignment.visibleTitleLengths
                            )
                          }}</span>

                          <!-- {{ assignment.visibleTitleLengths }} -->
                          <button
                            v-if="
                              assignment.title.length >
                              assignment.visibleTitleLengths
                            "
                            @click.stop="showMore(index, 'title')"
                            class="text-blue-500 ml-2"
                          >
                            Read More
                          </button>

                          <button
                            v-if="
                              assignment.title.length > 50 &&
                              assignment.title.length <
                                assignment.visibleTitleLengths
                            "
                            @click.stop="showLess(index, 'title')"
                            class="text-blue-500 ml-2"
                          >
                            See Less
                          </button>
                        </p>
                      </td>
                      <td class="px-4 py-3">
                        <p class="text-xs text-gray-500">
                          {{ assignment.duedate }}
                        </p>
                      </td>
                      <!-- {{ assignment.visibleLengths }} -->
                      <td class="px-4 py-3 md:!w-[250px]">
                        <p class="text-xs text-gray-600">
                          <span class="text-gray-500">{{
                            assignment.description.slice(
                              0,
                              assignment.visibleLengths
                            )
                          }}</span>

                          <!-- {{ assignment.visibleLengths }} -->
                          <button
                            v-if="
                              assignment.description.length >
                              assignment.visibleLengths
                            "
                            @click.stop="showMore(index, 'description')"
                            class="text-blue-500 ml-2"
                          >
                            Read More
                          </button>

                          <button
                            v-if="
                              assignment.description.length > 50 &&
                              assignment.description.length <
                                assignment.visibleLengths
                            "
                            @click.stop="showLess(index, 'description')"
                            class="text-blue-500 ml-2"
                          >
                            See Less
                          </button>
                        </p>
                      </td>
                      <td class="px-4 py-3 text-gray-500">
                        {{ assignment.student_assignment_data?.count || 0 }}
                      </td>
                      <td class="px-4 py-3">
                        <a
                          :href="assignment.file"
                          @click.stop
                          target="_blank"
                          download
                        >
                          <img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                          />
                        </a>
                      </td>

                      <td class="px-4 py-3">
                        <p
                          v-if="
                            assignment.student_assignment_data?.verify_status ==
                            'submitted'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="
                            assignment.student_assignment_data?.verify_status ==
                            'accepted'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else-if="
                            assignment.student_assignment_data?.verify_status ==
                            'rejected'
                          "
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid black; color: black"
                        >
                          <a class="text-black">N/A</a>
                        </p>
                      </td>
                      <td class="px-4 py-3 text-gray-500">
                        {{ assignment.student_assignment_data?.remark || "-" }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="this.getdetails"
                />
              </div>
            </div>

            <div v-else class="text-gray-500 mt-5">No data found</div>
          </div>
          <!-- <div class="h-full" v-else-if="submitted == 'submitted'">
            <div
              class="grid grid-cols-1 gap-10 mt-5 overflow-y-auto"
              v-if="submitassignmentInfo?.data?.length > 0"
            >
              <div class="w-full overflow-scroll border-b">
                <table class="min-w-full">
                  <thead>
                    <tr
                      class="text-left bg-[#18469d] text whitespace-nowrap text-sm"
                    >
                      <th class="px-6 py-3">Name</th>
                      <th class="px-6 py-3">Title</th>

                      <th class="px-6 py-3">Submit date</th>
                      <th class="px-6 py-3">Aproved</th>
                      <th class="px-6 py-3">Remark / Grade</th>
                      <th class="px-6 py-3">Download</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="assignment in submitassignmentInfo.data"
                      :key="assignment"
                      class="border-b pb-3"
                    >
                      <td class="px-6 py-3">
                        <img
                          class="w-20 h-16 object-cover rounded-md"
                          :src="require('@/assets/new/assignment.png')"
                          alt="Assignment"
                        />
                      </td>
                      <td class="px-6 py-3">
                        <router-link
                          :to="{
                            name: 'AssignmentDetail',
                            params: { assignment_id },
                          }"
                        >
                          <p
                            class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                          >
                            {{ assignment.title }}
                          </p>
                        </router-link>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          class="text-xs text-gray-600 text-left truncate mb-0"
                        >
                          Submited Date :
                          {{ formatDate(assignment.created_at) }}
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        <p
                          v-if="assignment.verify_status == 'submitted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Pending</a>
                        </p>

                        <p
                          v-else-if="assignment.verify_status == 'accepted'"
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #4bd08b; color: #4bd08b"
                        >
                          <a style="color: #4bd08b">Accepted</a>
                        </p>

                        <p
                          v-else
                          class="my-3 py-2 px-2 w-[120px] text-xs rounded-lg border text-center"
                          style="border: 1px solid #f87474; color: #f87474"
                        >
                          <a style="color: #f87474">Rejected</a>
                        </p>
                      </td>
                      <td class="px-6 py-3">
                        {{ assignment.remark || "-" }}
                      </td>
                      <td class="px-6 py-3">
                        <a :href="assignment.file" target="_blank" download
                          ><img
                            class="p-1 w-6 h-6 object-contain"
                            src="@/assets/new/download.png"
                            alt="Download"
                        /></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>No data Found</div>
          </div> -->
        </div>

        <!-- card -->

        <div v-else-if="tab === 'card'" class="px-5 lg:px-10 pb-4">
          <div class="flex items-center justify-between">
            <div class="flex flex-col lg:flex-row justify-between w-full">
              <h1 class="text-lg font-semibold">
                Assignments
                <span v-if="assignmentInfo != null">
                  ({{ this.assignmentInfo.count }})
                </span>
              </h1>
              <div class="flex flex-col lg:flex-row gap-3">
                <div>
                <select
                 ref="selectFilter"
                  name="model_select"
                  id="model_select"
                  v-model="selected_filter"
                  @change="getdetails(1)"
                  class="px-4 py-2 w-full md:w-[160px] rounded-xl text-sm cursor-pointer text-white bg-blues font-semibold focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors duration-200 hover:bg-blue-100 hover:text-black hover:border-blues border border-transparent"
                >
                  <option value="" disabled selected>Select sorting</option>
                  <option value="title">A to Z</option>
                  <option value="-title">Z to A</option>
                  <option value="created_at">New to Old</option>
                  <option value="-created_at">Old to New</option>
                </select>
              </div>

              <div class="relative w-full md:max-w-64">
                <form @submit.prevent="getdetails(1)">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="searching"
                    @input="getdetails(1)"
                    class="w-full pl-4 pr-10 py-1 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>
              </div>
            </div>
          </div>

          <div class="py-5 rounded flex gap-4 cursor-pointer">
            <p
              @click="this.submitted = 'assignment'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'assignment',
              }"
            >
              Assignments
            </p>
            <p
              @click="this.submitted = 'submitted'"
              :class="{
                'border-b-2 border-b-blues': this.submitted == 'submitted',
              }"
            >
              Submitted
            </p>
          </div>
          <div
            v-if="loading"
            class="flex items-center justify-center"
            style="height: calc(100vh - 350px) !important"
          >
            <img src="@/assets/newd/loading.gif" alt="" />
          </div>

          <div class="h-full" v-else-if="this.submitted == 'assignment'">
            <div
              class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 gap-10 mt-5 overflow-y-auto"
              v-if="assignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in assignmentInfo.data"
                :key="assignment"
                @click="pushDetailPage(assignment.id)"
                class="border rounded-2xl cursor-pointer px-5 py-5 flex flex-col gap-2 md:w-full"
              >
                <div>
                  <div class="relative flex justify-center items-center">
                    <img
                      class="rounded-xl w-full"
                      src="@/assets/new/assignment.png"
                      alt=""
                    />
                  </div>
                </div>

                <div class="text-center flex flex-col gap-1 justify-center">
                  <p
                    class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                  >
                    {{ assignment.title }}
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Due Date :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                    >
                      {{ assignment.duedate }}
                    </span>
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Description :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                      >{{ assignment.description }}
                    </span>
                  </p>

                  <div
                    class="px-1 flex items-center gap-3"
                    style="width: 100% !important"
                  >
                    <a
                      :href="assignment.file"
                      @click.stop
                      target="_blank"
                      download
                    >
                      <img
                        class="p-1 mb-1 rounded-lg"
                        style="
                          border: 1px solid #01b0f9;
                          width: 35px;
                          height: 30px;
                        "
                        src="@/assets/new/download.png"
                      />
                    </a>
                    <!-- 
                    <div
                      v-if="assignment.student_status != 'accepted'"
                      @click="checkAssignment(assignment)"
                      :disabled="assignment.student_status == 'accepted'"
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit</a>
                    </div> -->
                    <!-- <div
                      v-if="
                        assignment.student_assignment_data == null ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected' ||
                        assignment.student_assignment_data.verify_status !=
                          'submitted'
                      "
                      @click.stop="
                        this.assignmentPopup = !this.assignmentPopup;
                        this.assignmentId = assignment.id;
                      "
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit///</a>
                    </div>
                    <button
                      v-else-if="
                        assignment.student_assignment_data != null ||
                        assignment.student_assignment_data.verify_status ==
                          'submitted' ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected'
                      "
                      @click.stop="checkAssignment(assignment)"
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'cursor-not-allowed'
                          : 'cursor-pointer text-white'
                      "
                      class="border-[1px] border-[#01b0f9] w-[35px] h-[30px] rounded-md"
                    >
                      <img
                        src="@/assets/edit.svg"
                        alt=""
                        class="w-6 h-6 object-contain mx-auto"
                      />
                    </button> -->
                    <div v-if="assignment" class="w-full">
                      <button
                        v-if="
                          !assignment.student_assignment_data ||
                          (assignment.student_assignment_data?.verify_status !=
                            'accepted' &&
                            assignment.student_assignment_data?.verify_status !=
                              'submitted')
                        "
                        @click.stop="
                          this.assignmentPopup = !this.assignmentPopup;
                          this.assignmentId = assignment.id;
                        "
                        :disabled="
                          assignment.student_assignment_data?.verify_status ==
                          'accepted'
                        "
                        :class="
                          assignmentId === assignment.id && assignmentPopup
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                        "
                        class="text-xs rounded px-3 py-1 w-full"
                      >
                        Submit
                      </button>
                      <button
                        v-else-if="
                          assignment.student_assignment_data != null && [
                            assignment.student_assignment_data?.verify_status ==
                              'submitted' ||
                              assignment.student_assignment_data
                                ?.verify_status == 'rejected',
                          ] &&
                          assignment.student_assignment_data?.verify_status !=
                            'accepted'
                        "
                        @click.stop="checkAssignment(assignment)"
                        :disabled="
                          assignment.student_assignment_data?.verify_status ==
                          'accepted'
                        "
                        :class="
                          assignmentId === assignment.id && assignmentPopup
                            ? 'cursor-not-allowed'
                            : 'cursor-pointer text-white'
                        "
                      >
                        <img
                          src="@/assets/edit.svg"
                          alt=""
                          class="w-6 h-6 object-contain"
                        />
                      </button>
                      <!-- <p v-else>Submitted</p> -->
                      <button
                        v-else
                        class="text-green-600 w-full border text-xs border-green-600 px-4 py-1 rounded hover:bg-green-100 transition"
                      >
                        Submitted
                      </button>
                    </div>

                  
                  </div>
                    <div
                      class=" py-3 text-gray-500"
                      v-if="assignment.is_active == true"
                    >
                      <div class=""
                        v-if="
                          assignment.student_assignment_data != null && [
                            assignment.student_assignment_data
                              ?.verify_status === 'accepted' ||
                              assignment.student_assignment_data
                                ?.verify_status === 'rejected',
                          ]
                        "
                      >
                        <button
                          v-if="assignment.assignment_feedback.user_feedback"
                          @click.stop="openfeedback(assignment.id)"
                          class="flex items-center justify-center gap-1 w-full px-2 py-2 rounded-full bg-blue-100 text-blue-600  hover:bg-blue-200 transition-all"
                          title="View Full Description"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                            />
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                            />
                          </svg>
                          <span class="text-xs lg:text-sm font-medium">View Feedback</span>
                        </button>
                        <button
                          v-else
                          class="bg-gray-200 w-full text-blues px-3 py-1.5 rounded-full text-center hover:underline"
                          @click.stop="
                            this.feedbackPopup = !this.feedbackPopup;
                            this.assignmentId = assignment.id;
                          "
                        >
                          Click
                        </button>
                      </div>
                    </div>
                </div>
              </div>
            </div>
            <div v-else>No data Found</div>
          </div>

          <div class="h-full" v-else-if="submitted == 'submitted'">
            <div
              class="grid grid-cols-1 lg:grid-cols-3 2xl:grid-cols-5 gap-10 mt-5 overflow-y-auto"
              v-if="assignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in assignmentInfo.data"
                :key="assignment"
                @click="pushDetailPage(assignment.id)"
                class="border rounded-2xl cursor-pointer px-5 py-5 flex flex-col gap-2 md:w-full"
              >
                <div>
                  <div class="relative flex justify-center items-center">
                    <img
                      class="rounded-xl w-full"
                      src="@/assets/new/assignment.png"
                      alt=""
                    />
                  </div>
                </div>

                <div class="text-center flex flex-col gap-1 justify-center">
                  <p
                    class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                  >
                    {{ assignment.title }}
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Due Date :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                    >
                      {{ assignment.duedate }}
                    </span>
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Description :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                      >{{ assignment.description }}
                    </span>
                  </p>
                  <p class="text-xs text-gray-600 text-left truncate mb-0">
                    Attempt :
                    <span
                      class="text-gray-600"
                      style="color: #adadad !important"
                      >{{ assignment.student_assignment_data?.count || 0 }}
                    </span>
                  </p>
                  <div
                    class="px-1 flex items-center gap-3"
                    style="width: 100% !important"
                  >
                    <a
                      :href="assignment.file"
                      @click.stop
                      target="_blank"
                      download
                    >
                      <img
                        class="p-1 mb-1 rounded-lg"
                        style="
                          border: 1px solid #01b0f9;
                          width: 35px;
                          height: 30px;
                        "
                        src="@/assets/new/download.png"
                      />
                    </a>
                    <!-- 
                    <div
                      v-if="assignment.student_status != 'accepted'"
                      @click="checkAssignment(assignment)"
                      :disabled="assignment.student_status == 'accepted'"
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit</a>
                    </div> -->
                    <!-- <div
                      v-if="
                        assignment.student_assignment_data == null ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected' ||
                        assignment.student_assignment_data.verify_status !=
                          'submitted'
                      "
                      @click="
                        this.assignmentPopup = !this.assignmentPopup;
                        this.assignmentId = assignment.id;
                      "
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="text-xs rounded px-3 py-1 w-full"
                    >
                      <a>Submit</a>
                    </div>
                    <button
                      v-else-if="
                        assignment.student_assignment_data != null ||
                        assignment.student_assignment_data.verify_status ==
                          'submitted' ||
                        assignment.student_assignment_data.verify_status ==
                          'rejected'
                      "
                      @click="checkAssignment(assignment)"
                      :disabled="
                        assignment.student_assignment_data.verify_status ==
                        'accepted'
                      "
                      :class="
                        assignmentId === assignment.id && assignmentPopup
                          ? 'cursor-not-allowed'
                          : 'cursor-pointer text-white'
                      "
                      class="border-[1px] border-[#01b0f9] w-[35px] h-[30px] rounded-md"
                    >
                      <img
                        src="@/assets/edit.svg"
                        alt=""
                        class="w-6 h-6 object-contain mx-auto"
                      />
                    </button> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- <div
              class="grid lg:grid-cols-3 2xl:grid-cols-5 gap-10 mt-5 overflow-y-auto"
              v-if="submitassignmentInfo?.data?.length > 0"
            >
              <div
                v-for="assignment in submitassignmentInfo.data"
                :key="assignment"
                class="border rounded-2xl px-5 py-5 flex flex-col gap-2"
              >
                <div>
                  <div class="relative flex justify-center items-center">
                    <img
                      class="rounded-xl w-full"
                      src="@/assets/new/assignment.png"
                      alt=""
                    />
                  </div>
                </div>

                <p
                  class="text-sm text-gray-600 font-semibold text-left truncate mb-0 mt-2"
                >
                  {{ assignment.title }}
                </p>
                <p class="text-xs text-gray-600 text-left truncate mb-0">
                  Submited Date : {{ formatDate(assignment.created_at) }}
                </p>

                <div
                  class="px-1 flex items-center gap-3"
                  style="width: 100% !important"
                >
                  <p
                    v-if="assignment.verify_status == 'submitted'"
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #f87474; color: #f87474"
                  >
                    <a style="color: #f87474">Pending</a>
                  </p>

                  <p
                    v-else-if="assignment.verify_status == 'accepted'"
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #4bd08b; color: #4bd08b"
                  >
                    <a style="color: #4bd08b">Accepted</a>
                  </p>

                  <p
                    v-else
                    class="my-3 py-2 px-2 w-full text-xs rounded-lg border text-center"
                    style="border: 1px solid #f87474; color: #f87474"
                  >
                    <a style="color: #f87474">Rejected</a>
                  </p>
                  <div class="w-full">
                    <a :href="assignment.file" target="_blank" download
                      ><p
                        class="my-3 py-2 w-full text-xs rounded-lg border text-center text-black"
                      >
                        Download
                      </p></a
                    >
                  </div>
                </div>
               </div>
            </div> -->
            <div v-else>No data Found</div>
          </div>
        </div>
        <!-- assignment popup  -->
        <div
          v-if="this.assignmentPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Submit Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submitassignment"
                  @submit.prevent="scheduleAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments <span class="text-red-400">*</span></label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      required
                      accept=".txt,.doc,.docx"
                    />
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- edit assignment  -->
        <div
          v-if="this.assignmentEditPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="w-[90%] lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Update Assignment</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="this.assignmentEditPopup = false"
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submiteditassignment"
                  @submit.prevent="updateAssignment"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div
                    class="flex flex-col gap-2 w-full text-xs md:text-sm lg:text-base"
                  >
                    <div class="w-full flex flex-col gap-2">
                      <label for="title" class="text-left">Title</label>
                      <input
                        id="title"
                        type="text"
                        v-model="assignment_title"
                        class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                      />
                    </div>
                    <!-- <div class="w-full flex flex-col gap-2">
                        <label for="duedate" class="text-left"
                          >Submit date</label
                        >
                        <input
                          id="duedate"
                          type="date"
                          class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                        />
                      </div> -->
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      v-model="assignment_des"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full">
                    <label for="attachments" class="text-left"
                      >Attachments</label
                    >
                    <input
                      id="files"
                      type="file"
                      class="border bg-white border-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="inputchange"
                      accept=".txt,.doc,.docx"
                    />
                  </div>
                  <div class="flex gap-5 w-full text-xs text-blues">
                    <a
                      :href="this.assignment_file"
                      @click.stop
                      target="_blank"
                      download
                    >
                      {{ this.assignment_file }}
                    </a>
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- feed back create -->
        <div
          v-if="this.feedbackPopup"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[40%] bg-white rounded-xl p-10 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-between">
              <h3 class="text-xl font-bold text-blues">Submit Feedback</h3>
              <img
                src="@/assets/newd/close.png"
                class="cursor-pointer w-5 h-5 object-contain"
                alt=""
                @click="
                  this.feedbackPopup = false;
                  this.selectedRating = '';
                "
              />
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="submitfeedback"
                  @submit.prevent="scheduleFeedback"
                  class="flex flex-col gap-4 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="flex flex-col w-full gap-2">
                    <label for="description" class="text-left"
                      >Description</label
                    >
                    <textarea
                      id="description"
                      rows="3"
                      cols="10"
                      class="border border-gray-100 h-full rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>
                  <div class="flex flex-col w-full gap-2">
                    <!-- Label -->
                    <label
                      for="rating"
                      class="text-left text-sm font-medium text-gray-700"
                    >
                      Rating <span class="text-red-400">*</span>
                    </label>

                    <!-- Star Rating Preview -->
                    <div id="rating" class="flex items-center gap-1">
                      <template v-for="i in 5" :key="i">
                        <svg
                          @click="setRating(i)"
                          :class="[
                            'w-6 h-6 cursor-pointer transition-colors duration-200',
                            i <= selectedRating
                              ? 'text-yellow-400'
                              : 'text-gray-300',
                          ]"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                          />
                        </svg>
                      </template>
                    </div>
                  </div>
                  <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                    <button
                      type="submit"
                      :disabled="disable_submit == true"
                      :class="
                        this.disable_submit == true
                          ? 'bg-gray-200 text-black cursor-not-allowed'
                          : 'bg-blues hover:bg-[#18469d] cursor-pointer text-white'
                      "
                      class="rounded-lg text-sm px-10 py-2"
                    >
                      Submit
                    </button>
                    <img
                      v-if="disable_submit"
                      src="@/assets/loading.gif"
                      alt="loading"
                      class="w-6 h-6 object-contain"
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- feed back get -->
        <!-- view feedback -->
        <div
          v-if="feedbackModalOpen"
          class="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 px-4"
        >
          <div
            class="bg-white rounded-2xl shadow-2xl w-full max-w-xl max-h-[90vh] overflow-hidden flex flex-col relative"
          >
            <!-- Modal Header -->
            <div
              class="flex items-center justify-between p-5 border-b border-gray-200"
            >
              <h2 class="text-xl font-semibold text-gray-800">
                Feedback Details
              </h2>
              <button
                @click="feedbackModalOpen = false"
                class="text-gray-500 hover:text-red-500 text-2xl"
              >
                &times;
              </button>
            </div>
            <div class="flex flex-col gap-2 p-5">
              <!-- Description -->
              <div class="">
                <label class="text-sm font-medium text-gray-900 block mb-1">
                  Description:
                </label>
                <p class="text-gray-700 text-xs whitespace-pre-wrap">
                  {{ feedbacklist.text || "No description provided." }}
                </p>
              </div>

              <!-- Star Rating -->
              <div class="mb-4">
                <label class="text-sm font-medium text-gray-900 block mb-1">
                  Rating:
                </label>
                <div class="flex items-center gap-1">
                  <template v-for="i in 5" :key="i">
                    <svg
                      :class="[
                        'w-6 h-6 transition',
                        i <= feedbacklist.rating
                          ? 'text-yellow-400'
                          : 'text-gray-300',
                      ]"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 3.975a1 1 0 00.95.69h4.178c.969 0 1.371 1.24.588 1.81l-3.39 2.46a1 1 0 00-.364 1.118l1.287 3.976c.3.921-.755 1.688-1.538 1.118l-3.39-2.46a1 1 0 00-1.176 0l-3.39 2.46c-.783.57-1.838-.197-1.538-1.118l1.287-3.976a1 1 0 00-.364-1.118L2.05 9.402c-.783-.57-.38-1.81.588-1.81h4.178a1 1 0 00.95-.69l1.286-3.975z"
                      />
                    </svg>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import SideBar from "@/components/Student/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import Pagination from "@/components/Pagination.vue";
// import confirmPopup from "@/components/confirmPopup.vue";
// import leftNavigationStudent from "@/views/studentDashboard/leftnav.vue";
// import VuePdfEmbed from "vue-pdf-embed";

export default {
  data() {
    return {
      assignmentInfo: "",
      messages: {
        text: "",
        type: "null",
      },
      popupwindow: false,
      titlepass: null,
      idpass: null,
      assignmentPopup: false,
      assignmentEditPopup: false,
      assignmentEditPopup: false,
      editvalues: null,
      assignmentId: null,
      submitassignmentInfo: null,
      submitted: "assignment",
      assignmentsNull: false,
      is_detailsPopup: false,
      assignmentDetails: null,
      is_preview: false,
      courseDetailInfo: "",
      loading: true,
      tab: "list",
      disable_submit: false,
      assignment_title: "",
      assignment_des: "",
      assignment_file: "",
      update_assignment: "",
      totalPages: 1,
      current_page: 1,
      feedbackPopup: false,
      selectedRating: 0,
      deatilfeedback: false,
      feedbacklist: [],
      feedbackModalOpen: false,
      selected_filter:"",
      searching:"",
    };
  },

  props: ["course_id"],

  components: {
    SideBar,
    FlashMessage,
    Pagination,
    // confirmPopup,
    // leftNavigationStudent,
    // VuePdfEmbed,
  },

  created() {},

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
     document.addEventListener("click", this.handleClickOutside);
    axios
      .get(
        `${process.env.VUE_APP_API}/coursesdata/${this.course_id}/?Key=${this.userInfo.token_key}`
      )
      .then((response) => {
        this.courseDetailInfo = response.data;
      });
    setTimeout(() => {
      this.getdetails(1);
    }, 200);
  },
   beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
     handleClickOutside(event) {
      const select = this.$refs.selectFilter;
      if (select && !select.contains(event.target)) {
        this.selected_filter = "";
      }
    },
    setRating(rating) {
      this.selectedRating = rating;
    },
    showMore(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths += 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths += 50;
      }
    },
    showLess(index, val) {
      if (val == "title") {
        this.assignmentInfo.data[index].visibleTitleLengths = 50;
      } else {
        this.assignmentInfo.data[index].visibleLengths = 50;
      }
    },
    pushDetailPage(id) {
      this.$router.push({
        name: "AssignmentDetail",
        params: { assignment_id: id },
      });
    },
    setTab(view) {
      this.tab = view;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString("en-IN", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    detailsPopup(value) {
      this.is_detailsPopup = true;
      this.assignmentDetails = value;
    },

    async getdetails(page) {
      await axios
        .get(
          `${process.env.VUE_APP_API}/Inst_Assignment/view/?course_id=${this.course_id}&Key=${this.userInfo.token_key}&page=${page}&publish=true&search=${this.searching}&ordering=${this.selected_filter}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.assignmentInfo = response.data.data;
            this.totalPages = response.data.total_page;
            this.current_page = response.data.current_page;
            this.loading = false;
            if (Object.keys(this.assignmentInfo) == "error") {
              console.log("Null");
              this.assignmentsNull = false;
            } else {
              this.assignmentsNull = true;
              this.assignmentInfo?.data?.forEach((element) => {
                element["display_date"] = new Date(
                  element.duedate
                ).toLocaleDateString("en-IN", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                });
                element["visibleLengths"] = 50;
                element["visibleTitleLengths"] = 50;
              });
            }
          }
        });

      await axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment/view/?course_id=${this.course_id}&user=${this.userInfo.user.id}&Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          this.submitassignmentInfo = response.data;
          if (Object.keys(this.submitassignmentInfo) == "error") {
            console.log("Null");
          }
        });
    },
    checkAssignment(assignment) {
      this.assignment_title = assignment.student_assignment_data.title;
      this.assignment_des =
        assignment.student_assignment_data.student_description;
      this.assignmentEditPopup = !this.assignmentEditPopup;
      this.assignmentId = assignment.id;
      this.update_assignment = assignment.student_assignment_data.id;
      this.assignment_file = assignment.student_assignment_data.file;
    },
    // edit assignment
    async updateAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student-assignment-student-update/${this.update_assignment}/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      if (fileVal) {
        formData.append("file", fileVal);
      }
      formData.append("title", this.assignment_title);
      formData.append("student_description", this.assignment_des);

      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .put(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submiteditassignment.reset();
              this.assignmentEditPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // get assignment uploaded
    getAssignmentUploaded(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/student_assignment/new/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.getdetails(1);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },
    // student Submit Functions
    async scheduleAssignment(el) {
      this.disable_submit = true;
      let fileVal = el.target.elements.files.files[0];
      let urls = `${process.env.VUE_APP_API}/student_assignment/new/?Key=${this.userInfo.token_key}`;

      let formData = new FormData();
      formData.append("file", fileVal);
      formData.append("title", el.target.elements.title.value);
      formData.append(
        "student_description",
        el.target.elements.description.value
      );
      // formData.append("submit_date", el.target.elements.duedate.value);
      formData.append("verify_status", "submitted");
      formData.append("user", this.userInfo.user.id);
      formData.append("assignment_id", this.assignmentId);
      axios
        .post(urls, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.message == "your Assignment added successfully") {
            this.messages = {
              text: "Assignment Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitassignment.reset();
              this.assignmentPopup = false;
              this.disable_submit = false;
              this.assignmentId = "";
              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              // this.assignmentPopup = false;
              // this.getdetails();
            }, 1500);
          }
        });
    },

    async deleteAssignment(data) {
      this.popupwindow = false;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/assignment_deleted/${data}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          if (response.data.message == "Assignment deleted successfully") {
            this.messages = {
              text: "Assignment Deleted successfully",
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });

      await this.getdetails(this.current_page);
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
      }, 1500);
    },
    async scheduleFeedback() {
      this.disable_submit = true;
      let bodyVal = {
        assignment: this.assignmentId,
        text: document.getElementById("description").value,
        rating: this.selectedRating,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/assignment-feedback/create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 201) {
            this.messages = {
              text: "Feedback Submitted successfully",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.submitfeedback.reset();
              this.feedbackPopup = false;
              this.deatilfeedback = true;
              this.disable_submit = false;
              this.selectedRating = "";

              this.getdetails(this.current_page);
            }, 3000);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            this.disable_submit = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },

    async openfeedback(id) {
      console.log("ASdsdasd", id);
      this.feedbackModalOpen = true;
      await axios
        .get(
          `${process.env.VUE_APP_API}/assignment-feedback/update/delete/${id}/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.feedbacklist = res.data.data[0];
            console.log("  this.feedbacklist", this.feedbacklist.text);
          }
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
